import Enum from '@/api/constant/common'
export const baseURL = '/api/'
// export const baseURL = 'http://192.168.1.8:8000'
function MSTATUS_CHOICES(row, column) {
  if (row.mstatus === -3) {
    return '面过'
  } else if (row.mstatus === -2) {
    return '学习'
  } else if (row.mstatus === -1) {
    return 'offer'
  } else if (row.mstatus === 0) {
    return '拒offer'
  } else if (row.mstatus === 1) {
    return '在职'
  } else if (row.mstatus === 2) {
    return '离职'
  }
}
const mstatuslist = [
  {
    value: -3,
    label: '面过'
  },
  {
    value: -2,
    label: '学习'
  },
  {
    value: -1,
    label: 'offer'
  },
  {
    value: 0,
    label: '拒offer'
  },
  {
    value: 1,
    label: '在职'
  },
  {
    value: 2,
    label: '离职'
  }
]
// console.log(inventory.findIndex(findOrange));
function GENDER_CHOICES(row, column) {
  const rs = Enum.gender.find(item => item.value === row.gender)
  if (rs) {
    return rs.label
  } else {
    return row.gender
  }
}

function value2label(lis, v) {
  console.log(lis)
  if (lis) {
    const rs = lis.find(item => item.id === v)
    console.log('lis')
    if (rs) {
      return rs.sname
    }
    return ''
  } else {
    return ''
  }
}

function DEGREE_CHOICES(row, column) {
  const rs = Enum.Degree.find(item => item.value === row.education - 0)
  if (rs) {
    return rs.label
  } else {
    return row.education
  }
}

function TYPEOFCERTIFICATE_CHOICES(row, column) {
  var TypeOfCertificate = null
  if (row.Employee) {
    TypeOfCertificate = row.Employee.TypeOfCertificate
  } else {
    TypeOfCertificate = row.TypeOfCertificate
  }

  if (TypeOfCertificate === 0) {
    return '身份证'
  } else {
    return '其它'
  }
}
function JobOpportunityChoices(list, v) {
  const result = list.find(item => item.value === v)
  return result.label
}
function PACKAGEORBASE(row, column) {
  if (row.PackageOrBase === 1) {
    return '按照甲方包工资'
  } else if (row.PackageOrBase === 0) {
    return '按照乙方底工资'
  } else {
    return '其它'
  }
}
export { GENDER_CHOICES, DEGREE_CHOICES, value2label, MSTATUS_CHOICES, TYPEOFCERTIFICATE_CHOICES, mstatuslist, JobOpportunityChoices, PACKAGEORBASE }
